<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.registered_member") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-12.col-lg-4.col-xl-3.col-12.mb-1(v-if="!isOperator")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user
                  DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getListing()" size="sm")
              .form-group.col-md-12.col-lg-4.col-xl-5.col-12.mb-1
                DateRangePicker(:value="dateRange" @update="getData").mr-3
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getListing()"
                  variant="primary"
                  size="sm"
                ).mr-2
                jsonToExcel(v-if="registeredMemberList.length > 0" mode="RegisteredMember" :dttbl="registeredMemberListFull" :date="dateRange" type="1" :loading2="loading2")

          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12(style="max-height: 70vh; overflow: hidden;")
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover#tblList
                    thead.thead-light
                      tr
                        th.text-center(width="5%")
                          span #
                        th(width="10%")
                          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                        th(width="10%" @click="sortOrder('account_id')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id')")
                        th(width="10%" @click="sortOrder('contact_phone')")
                          span(:title="$t('ui.contact_phone')") {{ $t('ui.contact_phone') }}
                          .float-right
                            i(:class="changeSortKey('contact_phone')")
                        th(width="10%")
                          span(:title="$t('ui.upline')") {{ $t("ui.upline") }}
                        th(width="10%")
                          span(:title="$t('ui.affiliate')") {{ $t("ui.affiliate") }}
                        th.text-right(width="10%" @click="sortOrder('verified_date')")
                          span(:title="$t('ui.verified_date')") {{ $t("ui.verified_date") }}
                          .float-right
                            i(:class="changeSortKey('verified_date')")
                    tbody.clusterize-content
                      tr(v-if="registeredMemberList.length == 0")
                        td(colspan="7").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in registeredMemberList")
                        td.text-center
                          span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.parent_id") {{ item.parent_id }}&nbsp;
                        td
                          span(:title="item.account_id") {{ item.account_id }}&nbsp;
                        td
                          span(:title="item.contact_phone") {{ item.contact_phone }}&nbsp;
                        td
                          span(:title="item.referrer_id") {{ item.referrer_id }}&nbsp;
                        td
                          span(:title="item.affiliate_id") {{ item.affiliate_id }}&nbsp;
                        td.text-right
                          span(:title="$moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  data: () => ({
    loading2: false,
    loading: false,
    registeredMemberListFull: [],
    registeredMemberList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    searchID: '',
    sortKey: "claim_date",
    sortType: "desc",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.utmPageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.searchID = this.accountID
        this.getRegisteredMember(true);
        this.getRegisteredMemberFull();
      } else {
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        } else {
          this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        }

        if(this.searchID.trim() != '') {
          this.getRegisteredMember(true);
          this.getRegisteredMemberFull();
        }
      }
    }
  },
  methods: {
    getListing() {
      this.getRegisteredMember(true);
      this.getRegisteredMemberFull();
    },
    setReportStatementParam: function() {
      var json = {
        operator_id: this.searchID,
        member_id: this.$store.getters.reportStatement.member_id,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getRegisteredMember(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getRegisteredMember(true);
      this.getRegisteredMemberFull();
    },
    getRegisteredMemberFull: function(isSearch) {
      if (this.checkDateRange()) {
        if (this.searchID.trim() == '') {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.operatorIdRequired"), "error");
          return;
        }
        this.setReportStatementParam();
        let url = config.registeredMemberUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID.trim(),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.registeredMemberListFull = response.data.dt;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getRegisteredMember: function(isSearch) {
      if (this.checkDateRange()) {
        if (this.searchID.trim() == '') {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.operatorIdRequired"), "error");
          return;
        }
        let url = config.registeredMemberUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID.trim(),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.registeredMemberList = response.data.dt;
                  this.totalRow = this.registeredMemberList.length > 0 ? this.registeredMemberList[0].totalrows : 0;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setUTMPageSize", pageSize);
      this.currentPage = 1;
      this.getRegisteredMember(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getRegisteredMember();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>